module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/profile/profile.scss
// module id = ./web/modern/components/settings/profile/profile.scss
// module chunks = 0